import type {ReactElement} from 'react';
import {Pill, PILL_CONTENT_TYPE, PILL_SIZE, PILL_THEME, PILL_TYPE} from '@Components/pill/pill';
import {TextSize} from '@Components/text';
import type {BetaTagProps} from './beta-tag.types';

export function BetaTag({text, isDisabled = false}: BetaTagProps): ReactElement {
  // Not Pill's own isDisabled — that still uses the old grey tokens; this branch uses the newer disabled ones.
  if (isDisabled) {
    return (
      <Pill
        type={PILL_TYPE.ROUND}
        size={PILL_SIZE.XSMALL}
        background="bg-neutral-primary-disabled"
        content={{type: PILL_CONTENT_TYPE.TEXT, text, textSize: TextSize.XXSMALL, isBold: true, textColor: 'ct-neutral-primary-disabled'}}
      />
    );
  }

  return (
    <Pill type={PILL_TYPE.ROUND} theme={PILL_THEME.PRIMARY} size={PILL_SIZE.XSMALL} content={{type: PILL_CONTENT_TYPE.TEXT, text, textSize: TextSize.XXSMALL, isBold: true}} />
  );
}
